import { OfferFragment } from '@occc/graphql';

import { ScheduleFormValues, ScheduleFieldPaths } from './types';
import { getMarketingContentOperations } from './getMarketingContentOperations';
import { makeOfferUpdateOperation } from './makeOfferUpdateOperation';
import { isFieldDirty } from '../utils';
import { DirtyFieldsType, Operation } from '../types';

const fieldsToCheckForOfferUpdate: ScheduleFieldPaths[] = [
  'publishAtTime',
  'publishAtDate',
  'expireAtTime',
  'expireAtDate',
  'triggerPreferences.triggerOnVisibility',
  'triggerPreferences.triggerOnFulfillment',
  'triggerPreferences.triggerOnProgress',
];

const fieldsToCheckForMarketingContentOperations: ScheduleFieldPaths[] = [
  'marketingContent.triggeredMessageContent.fulfillmentSms',
  'marketingContent.triggeredMessageContent.visibilitySms',
  'marketingContent.triggeredMessageContent.progressSms',
];

export const getScheduleOperations = (
  offerId: string,
  _offer: OfferFragment | undefined,
  values: ScheduleFormValues,
  dirtyFields: DirtyFieldsType,
) => {
  const operations: Operation[] = [];

  if (
    fieldsToCheckForOfferUpdate.some((field) =>
      isFieldDirty<ScheduleFormValues>(dirtyFields, field),
    )
  ) {
    operations.push(makeOfferUpdateOperation(offerId, values));
  }

  if (
    fieldsToCheckForMarketingContentOperations.some((field) =>
      isFieldDirty<ScheduleFormValues>(dirtyFields, field),
    )
  ) {
    operations.push(getMarketingContentOperations(values, offerId));
  }

  return operations;
};
